import { getMultipleRefCompsIdFromInflatedId, getUniqueId } from '@wix/thunderbolt-commons'
import { createConsumptionDataNode } from './utils/dataNodeUtils'
import type { Triggers as TriggerType, BaseDataItem } from '@wix/thunderbolt-becky-types'
import { removeHash } from '@wix/thunderbolt-catharsis'
import { getOverrideItem } from '../../dataConsumption'
import type { DataItemWithOverridesRefs } from '../../types'

const getResolvedOverrideItemNestingLevel = (items: Readonly<Array<BaseDataItem | undefined>>) =>
	items.findIndex(Boolean)!

export const Triggers = createConsumptionDataNode<null, null, DataItemWithOverridesRefs>({
	toViewItem: ({ id, value: { dataItemWithOverrides } }) => {
		const dataItem = getOverrideItem(dataItemWithOverrides)
		if (!dataItem) {
			return
		}
		const overrideIndex = getResolvedOverrideItemNestingLevel(dataItemWithOverrides)

		// if the override is in the consumer level, we don't need to inflate the slots ids
		if (overrideIndex === 0) {
			return dataItem
		}

		const ancestorsChain = getMultipleRefCompsIdFromInflatedId(id)
		const values = (dataItem as TriggerType).values.map(
			(variantId: string) => `#${getUniqueId(ancestorsChain, removeHash(variantId))}`
		)
		return {
			...dataItem,
			values,
			id,
		}
	},
})
